import { DEFAULT_LICENSE_COUNT, MIN_LICENSE_COUNT } from '@coursera-web/wes-common';

import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

// WES Payment Gateway - BT/Stripe
export const generateImpressionForPg = () => EnterpriseExperiments.get('paymentGatewayToBeDisplayed');
export const isStripeEnabled = () =>
  EnterpriseExperiments.preview('paymentGatewayToBeDisplayed') === 'stripeEnterpriseWes';

// WES Self Serve Invoicing Flow
export const generateImpressionForSelfServeInvoicing = () => EnterpriseExperiments.get('isSelfServeInvoice');
export const previewImpressionForSelfServeInvoicing = () => EnterpriseExperiments.preview('isSelfServeInvoice');

// WES Differential Pricing
export const generateImpressionForDifferentialPricing = () => EnterpriseExperiments.get('showDifferentialPricing');
export const previewImpressionForDifferentialPricing = () => EnterpriseExperiments.preview('showDifferentialPricing');

// WES Default License Count
export const generateImpressionForDefaultLicenseTo10 = () => EnterpriseExperiments.get('enableDefaultLicenseTo10');
export const previewDefaultLicenseTo10 = () => EnterpriseExperiments.preview('enableDefaultLicenseTo10');
export const getDefaultLicenseCount = (generateImpression = false) => {
  const isDefaultLicenceTo10Enabled = generateImpression
    ? generateImpressionForDefaultLicenseTo10()
    : previewDefaultLicenseTo10();
  return isDefaultLicenceTo10Enabled ? DEFAULT_LICENSE_COUNT : MIN_LICENSE_COUNT;
};
